// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".eos-keypriorities__datepicker[data-v-59554fdf]  .v-chip{width:100%;margin:0!important}.eos-keypriorities__datepicker[data-v-59554fdf]  .v-chip:not(:hover){border-color:#a1a1a1!important}", ""]);
// Exports
module.exports = exports;
